export function isMobile(userAgent: string | null) {
  if (!userAgent) return false;

  const regex =
    /\b(Mobi|Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini)\b/i;
  return regex.test(userAgent);
}
